<template >
  <v-flex xs12 v-if="user != null">
    <v-container flat class="primary">
      <v-layout row wrap>
        <v-flex xs12>
          <v-card class="CardUser">
            <v-layout row>
              <v-flex xs5 sm2>
                <v-avatar :size="100" color="grey lighten-4">
                  <v-icon large>account_circle</v-icon>
                </v-avatar>
              </v-flex>
              <v-flex>
                <v-card-title primary-title>
                  <div>
                    <h3>{{this.$auth.user().email}}</h3>
                    <p>{{this.$auth.user().email}}</p>
                  </div>
                </v-card-title>
              </v-flex>
            </v-layout>
            <v-divider light class="mt-2"></v-divider>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-flex>
</template>

<script>
import avatar from "../../assets/logo.png";
import { mapActions } from "vuex";
import { mapState } from "vuex";

export default {
  data() {
    return {
      name: "Leandro Rodrigues",
      job: "Empreendedor",
      logoAvatar: avatar
    };
  },
  computed: mapState({
    oneUser: state => state.Users.oneUser,
    user: state => state.Users.user,
    allUsers: state => state.Users.allUsers
  }),
  methods: {
    ...mapActions({
      // showOneUser: 'Users/showOneUser'
    })
  }
};
</script>

<style scoped>
.CardUser {
  padding: 20px;
}
</style>